import React, { useState,useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Card,Input} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes  } from "@fortawesome/free-solid-svg-icons";
import FetchCMProductDataService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchCMProductDataService';
import ProjectDashGraphicQA from './ProjectDashGraphicQA';
import GetCMFileListBySubCategoryService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/GetCMFileListBySubCategoryService';
import getCMAssetCountsByASINService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/getCMAssetCountsByASINService';

function ProjectAsinCardsUi(props) {
    const [searchASIN, setSearchASIN] = useState('');
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedASIN, setSelectedASIN] = useState(null);
    const [productList, setProductList]=useState('');
    const [loading, setLoading] = useState(false)
    const [fileList, setFileList] = useState([])
    const [fileStatus, setFileStatus] = useState('')
    const [filterSubcategoryList, setFilterSubcategoryList] = useState()
    const[allOriginalFiles,setAllOriginalFiles]=useState([])
    const [loggedInUser,setLoggedInUser]=useState()
    const [assetsStatusCount,setAssetsStatusCount]=useState({})
    const [asinAssetCounts, setAsinAssetCounts] = useState({});
    useEffect(()=>{

      const data = {
          asinList: props.selectedProjectData.asin,
          projectId: props.selectedProjectData.projectId,
          integerID: props.selectedProjectData.integerId,
        }
      FetchCMProductDataService(props.token,data).then((res)=>{
          if(res){
              console.log(res)
              setProductList(res.productsList)
              fetchAssetCounts(res.productsList);
          }
      })
  },[])
  const fetchAssetCounts = (products) => {
    const asinList = products ? products.map(p => p.asin) : [];
    console.log(asinList)
    
    const data = {
        asinList: asinList,
        integerId: props.selectedProjectData.integerId,
        assetCategory: props.selectedSubCategories.assetCategory,
        subCategoryId: props.selectedSubCategories.id,
        projectId: props.selectedProjectData.projectId,
    };

    getCMAssetCountsByASINService(props.token, data).then((res) => {
      console.log("API response:", res);
  
      if (res) {
          console.log("Setting asinAssetCounts:", res);
          setAsinAssetCounts(res);  
      }
  });
}

  const handleSelectAsinAssets=(asin)=>{
    setLoading(true)
    let asinList=''
    if( asin=='Unmapped Assets'){
      asinList='Unmapped Assets'
    }
    else{
      asinList=asin
    }
    let data={
      // asin:asin,
      integerId: props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories.assetCategory,
      // assetIdentifier: asin,
      asinList:asinList,
      assetIdentifier: props.selectedProjectData.brand,
      subCategoryId: props.selectedSubCategories.id,
      projectId:props.selectedProjectData.projectId,
    }
    GetCMFileListBySubCategoryService(props.token,data).then((res)=>{
      if(res){
        console.log(res)
        setFileList(res.fileList)
        setSelectedImage(res.fileList.length > 0 ? res.fileList[0] : '')
        setLoggedInUser(res.loggedInUser)
        setFileStatus(res.statusList)
        setAllOriginalFiles(res.originalFiles)
        setFilterSubcategoryList(res.brandSubcategoryList)
        // Set status count if available
        if(res.assetStatusCount){
          console.log('Status count:', res.assetStatusCount)
          setAssetsStatusCount(res.assetStatusCount)
        }
        
        setLoading(false) 
        setSelectedASIN(asin)
      }
    })
  }
const filteredProductList = productList
  ? productList.filter(asinObj =>
      asinObj.asin.toLowerCase().includes(searchASIN.toLowerCase())) : [];
const othersCount =
    asinAssetCounts["Unmapped Assets"] !== undefined
      ? asinAssetCounts["Unmapped Assets"]
      : 0; 
  return (
    <>
       {!selectedASIN ? (
      <>
        {/* ASIN Selection UI */}
        <Row className="align-items-center ml-2 mb-1 justify-content-between">
          <Col md={6} className="d-flex align-items-center">
            <b>Select ASIN:</b>
          </Col>
          <Col md={6} className="d-flex justify-content-end position-relative">
            <Input
              value={searchASIN}
              onChange={(e) => setSearchASIN(e.target.value)}
              placeholder="Search ASIN"
              className="w-50 pr-5"
            />
            {searchASIN && (
              <button
                className="search-clear-button"
                title="Clear"
                onClick={() => setSearchASIN('')}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            )}
          </Col>
        </Row>

        <Row>
          <Col md={3}>
            <Card
              className="mb-3 ml-3 mt-3 p-3 text-center asin-card"
              onClick={() => handleSelectAsinAssets("Unmapped Assets")}
              style={{ cursor: "pointer", position: "relative" , backgroundColor: "#dbc5e6"}}
            >
              <b>Unmapped Assets</b>
              <b
                className="assetsStatusCount"
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  minWidth: `${Math.max(26, othersCount.toString().length * 10)}px`,
                  minHeight: `${Math.max(26, othersCount.toString().length * 10)}px`,
                }}
              >
                {othersCount}
              </b>
            </Card>
          </Col>
              {filteredProductList &&
                  filteredProductList.map((asin, index) => {
                          const count =
                  asinAssetCounts[asin.asin] !== undefined
                    ? asinAssetCounts[asin.asin]
                    : 0;
                    return (
                            <Col md={3} key={index}>
                            <Card
                              title={asin.productTitle}
                              className="mb-3 ml-3 mt-3 p-3 asin-card"
                              onClick={() => handleSelectAsinAssets(asin.asin)}
                              style={{ cursor: "pointer", position: "relative" }}
                            >
                              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                <img
                                  src={asin.itemImage}
                                  alt={asin.productTitle}
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    objectFit: "contain",
                                    borderRadius: "6px",
                                  }}
                                />

                                <b style={{ fontSize: "14px" }}>{asin.asin}</b>
                              </div>

                              {/* Count Bubble */}
                              <b
                                className="assetsStatusCount"
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  minWidth: `${Math.max(26, count.toString().length * 10)}px`,
                                  minHeight: `${Math.max(26, count.toString().length * 10)}px`,
                                }}
                              >
                                {count}
                              </b>
                            </Card>


                            </Col>
                            )
                    })}
        </Row>
    </>
        ) : (
      <ProjectDashGraphicQA
      loggedInUser={loggedInUser}
      setAllOriginalFiles={setAllOriginalFiles}
      allOriginalFiles={allOriginalFiles}
      selectedASIN={selectedASIN}
      setSelectedASIN={setSelectedASIN}
      setSelectedImage={setSelectedImage}
      selectedImage={selectedImage}
      assetsStatusCount={assetsStatusCount}
      setAssetsStatusCount={setAssetsStatusCount}
      fileList={fileList}
      setAsinAssetCounts={setAsinAssetCounts}
      assetIdentifier={props.selectedProjectData.brand}
      selectedSubCategories={props.selectedSubCategories}
      // asin={asin}
      selectedProjectData={props.selectedProjectData}
      setFileList={setFileList}
      fileStatus={fileStatus}
      setFileStatus={setFileStatus}
      setFilterSubcategoryList={setFilterSubcategoryList}
      filterSubcategoryList={filterSubcategoryList}
      projectPermissions={props.projectPermissions}
      />
      
    )}
  </>
  )
}
const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,

});
export default connect(mapStateToProps)(ProjectAsinCardsUi);
